import { gql } from "apollo-angular";

export const GETALL_SW_COVERAGE_QUERY = gql`query configuratorAllSoftwareVersionCoverages($RegBy: String) {
    configuratorAllSoftwareVersionCoverages(RegBy: $RegBy) {
        Version
        Uid
        ItemNo
        Name
        ModifiedBy
        ModificationTime
        LockedTime
        LockedBy
        CreationTime
        CreatedBy
        Comment
        ApprovedForTestLevel
        ApprovalStatus
    }
  }
  `
  
export const GET_SW_COVERAGE_QUERY = gql`query configuratorSoftwareVersionCoverageById($Uid: String!) {
    configuratorSoftwareVersionCoverageById(Uid: $Uid) {
        responseMessages
        returnValue
        success
    }
  }
  `

export const GET_SW_COVERAGE_UI_TEMPLATE_QUERY = gql`query configuratorSoftwareVersionCoverageUiTemplate {
    configuratorSoftwareVersionCoverageUiTemplate {
        Name
        Category
        DefaultValue
        FieldType
        IsMultiValue
        HasHierarchyValues
        IsReadOnly
        Label
        IsRequired
        Order
        Tooltip
        ValueList
    }
  }
  `
export const GET_SW_COVERAGE_SEARCH_UI_TEMPLATE_QUERY = gql`query configuratorSoftwareVersionCoverageSearchUiTemplate {
    configuratorSoftwareVersionCoverageSearchUiTemplate {
        Name
        Label
        Category
        DefaultValue
        Order
        FieldType
        Tooltip
        IsReadOnly
        IsRequired
        IsMultiValue
        HasHierarchyValues
        ValueList
    }
  }
  `

export const SEARCH_SW_COVERAGE_QUERY = gql`query configuratorSearchSoftwareVersionCoverage($SoftwareVersionCoverage: SoftwareVersionCoverageInput) {
  configuratorSearchSoftwareVersionCoverage(SoftwareVersionCoverage: $SoftwareVersionCoverage) {
        Version
        Uid
        ItemNo
        Name
        ModifiedBy
        ModificationTime
        LockedTime
        LockedBy
        CreationTime
        CreatedBy
        Comment
        ApprovedForTestLevel
        ApprovalStatus
    }
}
`